import React from 'react';
import Input from '../../Input';
import {useTranslation} from '../../../hooks/useTranslation';

export default function TextField({
  id,
  label,
  setFields,
  type,
  value,
  fields,
  field,
  readOnly,
}) {
  const {t} = useTranslation();
  return (
    <div className='equipment__container'>
      <Input
        label={label}
        type={type}
        id={id}
        containerWidth={'100%'}
        defaultValue={!value ? '' : value}
        onChange={e => {
          setFields(old => {
            let data = [
              ...old.map(item => {
                let newArray = {...item};
                if (newArray?.key === id) {
                  newArray.value = e.target.value;
                }
                return newArray;
              }),
            ];
            return data;
          });
        }}
        readOnly={readOnly}
        title={readOnly ? t('createEquipment.readOnly') : undefined}
        inputStyles={
          readOnly
            ? {backgroundColor: '#E9EAEB', cursor: 'not-allowed'}
            : {}
        }
      />
    </div>
  );
}
